import { collection, getDocs, query, where, onSnapshot } from "firebase/firestore";
import { db, auth } from "../firebaseConfig";
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { ThreeDots } from "react-loader-spinner";
import ReactPaginate from 'react-paginate';
import Swal from 'sweetalert2';
import { Text } from "slate";
import ManageUsers from "./ManageUsers";
import AddViolation from "./AddViolation";
import BulkEdit from "./BulkEdit";
import EditContent from "./EditContent";
import Navbar from "../components/Navbar"
import ViolationCard from "../components/ViolationCard";
import React from 'react';

export default function AdminDash() {
    const userAuth = auth.currentUser;
    const navigate = useNavigate();
    const [violations, setViolations] = useState([]);
    const [violationTitleInput, setViolationTitleInput] = useState("");
    const [editViolation, setEditViolation] = useState(null);
    const [userCheck, setUserCheck] = useState(null);
    const [sortValue, setSortValue] = useState("");
    const [addCheck, setAddCheck] = useState(false);
    const [bulkCheck, setBulkCheck] = useState(false);
    const [editContent, setEditContent] = useState(false);
    const [user, setUser] = useState([]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openMenuRowName, setOpenMenuRowName] = useState(null);

    const filteredViolations = violations.filter(v =>
        v.arsCode.toLowerCase().includes(violationTitleInput.toLowerCase())
    );

    const itemsPerPage = 10;
    const totalPages = Math.ceil(filteredViolations.length / itemsPerPage);
    const [currPage, setCurrPage] = useState(1);
    const currentItems = filteredViolations.slice((currPage - 1) * itemsPerPage, currPage * itemsPerPage);

    const handleClick = (event, rowName) => {
        setAnchorEl(event.currentTarget);
        setOpenMenuRowName(rowName);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setOpenMenuRowName(null);
    };

    useEffect(() => {
        
        const activeViolationsQuery = query(
            collection(db, "violations"),
            where("effectiveEndDate", "==", null)
        );
    
        const unsubscribe = onSnapshot(activeViolationsQuery, (querySnapshot) => {
            let violationsArray = querySnapshot.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }));
    
            if (sortValue === "arsCode-asc") {
                violationsArray.sort((a, b) => a.arsCode.localeCompare(b.arsCode));
            } 
            
            else if (sortValue === "arsCode-desc") {
                violationsArray.sort((a, b) => b.arsCode.localeCompare(a.arsCode));
            } 

            else if (sortValue === "startDate-asc") { 
                violationsArray.sort((a, b) => a.effectiveStartDate.toDate().getTime() - b.effectiveStartDate.toDate().getTime()); 
            } 
              
            else if (sortValue === "startDate-desc") { 
                violationsArray.sort((a, b) => b.effectiveStartDate.toDate().getTime() - a.effectiveStartDate.toDate().getTime()); 
            }
            
            else if (sortValue === "fine-asc") {
                violationsArray.sort((a, b) => parseFloat(a.fine) - parseFloat(b.fine));
            } 
            
            else if (sortValue === "fine-desc") {
                violationsArray.sort((a, b) => parseFloat(b.fine) - parseFloat(a.fine));
            }

            else if (sortValue === "proof-info") {
                violationsArray.sort((a, b) => {
                    const aHasProofOrInfo = hasText(a.acceptableProof) || hasText(a.additionalInfo);
                    const bHasProofOrInfo = hasText(b.acceptableProof) || hasText(b.additionalInfo);
                    if (aHasProofOrInfo === bHasProofOrInfo) return 0;
                    return aHasProofOrInfo ? -1 : 1;
                });
            }
    
            setViolations(prev => {
                if (editViolation) return prev;
                return violationsArray;
            });
              
            if (currPage <= Math.ceil(violationsArray.length / itemsPerPage)) {
                navigate(`/dashboard/page/${currPage}`, { replace: true });
            }

            if (editViolation && !violationsArray.some(v => v.id === editViolation.id)) {
                setEditViolation(null);
            }
        
        }, (error) => {
            console.error("Firestore snapshot error:", error);
        });
    
        return () => unsubscribe();
        
    }, [sortValue, editViolation, navigate, currPage]);
    

    const printAllUsers = async () => {
        try {
            const userCollection = await getDocs(collection(db, "users"));
            const userArray = userCollection.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
            }));
            setUser(userArray);
        } catch (e) {
            Swal.fire({ 
                icon: "error",
                title: "Error",
                text: e,
                confirmButtonColor: "#3085d6",
            });
        }
    };

    const handlePageClick = (e) => {
        setCurrPage(e.selected + 1);
        navigate(`/dashboard/page/${e.selected + 1}`);
        document.getElementById('dashboard').scrollTo({ top: 0});
    }
    
    const hasText = (nodes) => {
        if (!Array.isArray(nodes)) return false;
        
        return nodes.some(node => {
            // Check if the node itself is a text node 
            if (Text.isText(node) && node.text && node.text.trim() !== "") {
                return true;
            }
    
            // Check if the node is a block/element (like a paragraph, list item, or link)
            if (Array.isArray(node.children)) {
                // Check the children
                return node.children.some(child => {
                    if (Text.isText(child) && child.text && child.text.trim() !== "") {
                        return true;
                    }
                    
                    if (child.type === 'link') {
                        return true;
                    }
                    
                    return false;
                });
            }
            
            if (node.type === 'link') {
                return true;
            }
    
            return false;
        });
    };

    const showPageTotal = () => {
        if (filteredViolations.length === 0) {
            return (
                <>
                    <p style={{marginLeft: "25px"}}>No options Found</p>
                    <p className="print-page-length">Showing 0 of 0</p>
                </>
            )
        };
        const first = (currPage - 1) * itemsPerPage + 1;
        const last = Math.min( currPage * itemsPerPage, filteredViolations.length);
    
        return (
            <p className="print-page-length">Showing {first} - {last} of {filteredViolations.length}</p>
        );
    };

    
    return (
        <div className="dashboard" id="dashboard">
            <Navbar printAllUsers={printAllUsers} setUserCheck={setUserCheck} setAddCheck={setAddCheck} sortValue={sortValue} setSortValue={setSortValue}
                setViolationTitleInput={setViolationTitleInput} violationTitleInput={violationTitleInput} violations={violations} setCurrPage={setCurrPage} setBulkCheck={setBulkCheck} 
                setEditContent={setEditContent}/>
        
            {(userCheck) ? (
                <ManageUsers printAllUsers={printAllUsers} user={user} setUser={setUser} setUserCheck={setUserCheck} handleClick={handleClick} 
                handleClose={handleClose} anchorEl={anchorEl} openMenuRowName={openMenuRowName} ></ManageUsers>
                
            ) : ((addCheck) ? (
                <AddViolation setAddCheck={setAddCheck} userAuth={userAuth.email}/>

            ) : (bulkCheck) ? (
                
                <BulkEdit setBulkCheck={setBulkCheck} user={userAuth.email}/>

            ) : (editContent) ? (
                <EditContent setEditContent={setEditContent}/>

            ) : (violations.length > 0 ? (
                <>
                    <ViolationCard currentItems={currentItems} hasText={hasText} setViolations={setViolations} editViolation={editViolation} setEditViolation={setEditViolation}/>
                    {totalPages > 0 && (
                        <ReactPaginate previousLabel={"<"} nextLabel={">"} breakLabel={".."} breakClassName={"break-me"}
                            forcePage={currPage - 1}
                            pageCount={totalPages} 
                            marginPagesDisplayed={2} 
                            pageRangeDisplayed={2}
                            onPageChange={handlePageClick}
                            containerClassName={"pagination"}
                            activeClassName={"active"}/>
                    )} 
                    {showPageTotal()}            
                </>
            ) : (
                <ThreeDots color="#00BFFF" height={80} width={80} style={{width: "88%"}}/>
            )))}    

    </div>

    );

}
